
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 0A13.5 13.5 0 110 13.5 13.5 13.5 0 0113.5 0z","fill":"#ea344b"}}),_c('g',{attrs:{"fill":"#fcfcfe"}},[_c('path',{attrs:{"d":"M13.637 16.849a3.275 3.275 0 003.2-3.324V8.691a3.2 3.2 0 00-3.088-3.315h-.113a3.207 3.207 0 00-3.2 3.1v5.049a3.276 3.276 0 003.201 3.324z"}}),_c('path',{attrs:{"d":"M18.592 11.509a.6.6 0 00-.594.6v1.414a4.363 4.363 0 11-8.726.121v-1.545a.592.592 0 00-1.184 0v1.416a5.54 5.54 0 004.957 5.52v1.682h-1.532a.6.6 0 00-.6.589.593.593 0 00.591.6h4.258a.594.594 0 100-1.188h-1.535v-1.682a5.539 5.539 0 004.956-5.52v-1.417a.6.6 0 00-.591-.59z"}})])])
          )
        }
      }
    